import * as React from 'react'

import { AnchorLink } from 'gatsby-plugin-anchor-links'


export default ({ href, title, className }) => {
  return <AnchorLink to={href} title={title} className={className || 'header-link'} stripHash />
}